import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/_org/transactions")({
  component: RouteComponent,
  loader: ({ context: { queryClient, trpc } }) => {
    queryClient.ensureQueryData(trpc.transaction.list.queryOptions());
    queryClient.ensureQueryData(trpc.tag.list.queryOptions());
  },
});

function RouteComponent() {
  const location = useLocation();
  const navigate = Route.useNavigate();

  if (location.pathname === "/transactions") {
    return navigate({
      to: "/transactions/card",
    });
  }
  return <Outlet />;
}
